import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('unhandled UI error', error, info);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="flex h-full items-center justify-center px-6 text-center">
        <div>
          <h1 className="text-xl font-semibold tracking-tight text-ink">Something went wrong</h1>
          <p className="mt-2 text-[13px] text-ink-muted">
            The conversation could not be displayed.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 rounded-lg border border-hairline bg-surface px-3.5 py-2 text-[13px]
              text-ink transition-colors hover:border-accent/60"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }
}
